import DocumentUploadList from "./DocumentUploadList";

export default DocumentUploadList;
